import * as $ from 'jquery';
import {ActualScreen, Breakpoints, getActualScreen} from 'Core/Responsiveness';
import {onClick, onLoad} from 'Core/Events';


export const LoginPanel = (() => {

    const Selector = {
        BODY: 'body',
        TOGGLER: '#login-panel--toggler, #login-panel--toggler-desktop',
        CART_STEP2_LOGIN_BTN: '#cart-step2-header-login-btn',
        CART_STEP2_LOGIN_A: '#cart-step2-header-login-a',
        LOGIN_PANEL: '#login-panel',
        LOGIN_PANEL_WRAPPER: '#login-panel-wrapper, #login-panel-wrapper-desktop',
        REMIND_PASSWORD_BTN: '#remind-password-btn',
        REMIND_PASSWORD_PANEL: '#remind-password-panel',
        BACK_TO_LOGIN_PANEL_BTN: '#back-to-login-from-remind-panel',
        DARK_OVERLAY: '.dark-overlay--for-login',
        NAVBAR_COLLAPSE: '.navbar-collapse',
        MESSAGE_MODAL: '#MessageModal',
        CLOSE_BTN: '.close-panel-button',
        TOOLTIP: '[data-toggle="tooltip"]'
    };

    onLoad(showModalAfterLogin);
    onClick(Selector.TOGGLER, togglePanelVis);
    onClick(Selector.CART_STEP2_LOGIN_BTN, togglePanelVis);
    onClick(Selector.CART_STEP2_LOGIN_A, togglePanelVis);
    onClick(Selector.REMIND_PASSWORD_BTN, showRemindPasswordPanel);
    onClick(Selector.BACK_TO_LOGIN_PANEL_BTN, backFromRemindPasswordPanel);
    onClick(Selector.CLOSE_BTN, closeLoginModal);

    function togglePanelVis(e: JQueryEventObject) {
        e.stopPropagation();
        $(Selector.TOOLTIP).tooltip('hide');
        
        // Find the login panel within the same wrapper as the clicked toggler
        const $toggler = $(e.currentTarget);
        let $wrapper = $toggler.closest(Selector.LOGIN_PANEL_WRAPPER);
        
        // If button is not inside a wrapper (e.g. cart step2 login button), find the visible one in the header
        if (!$wrapper.length) {
            $wrapper = $(Selector.LOGIN_PANEL_WRAPPER).filter(':visible').first();
        }
        
        const $loginPanel = $wrapper.find(Selector.LOGIN_PANEL);
        const $remindPanel = $wrapper.find(Selector.REMIND_PASSWORD_PANEL);
        
        if ($loginPanel.is(':visible') || $remindPanel.is(':visible')) {
            $loginPanel.fadeOut('fast');
            $remindPanel.fadeOut('fast');

        } else {
            $loginPanel.fadeIn();
            getActualScreen();
            if (ActualScreen.WIDTH <= Breakpoints.LG) {
                $loginPanel.fadeIn();
                $(Selector.NAVBAR_COLLAPSE).fadeIn('fast');
                // ^ If login-panel is placed inside navbar, navbar has to be expanded if you want to show him. Otherwise you will show Dark overlay only, without panel
                $(Selector.DARK_OVERLAY).fadeIn('fast');
                $(Selector.BODY).addClass('overflow-hidden');
            }
        }
    }

    //  REMIND PASSWORD FUNCTIONALITY
    function showRemindPasswordPanel(e) {
        e.stopPropagation();
        const $btn = $(e.currentTarget);
        const $wrapper = $btn.closest(Selector.LOGIN_PANEL_WRAPPER);
        $wrapper.find(Selector.LOGIN_PANEL).fadeOut();
        $wrapper.find(Selector.REMIND_PASSWORD_PANEL).fadeIn();
        return false;
    }

    function backFromRemindPasswordPanel(e) {
        e.stopPropagation();
        const $btn = $(e.currentTarget);
        const $wrapper = $btn.closest(Selector.LOGIN_PANEL_WRAPPER);
        $wrapper.find(Selector.REMIND_PASSWORD_PANEL).fadeOut();
        $wrapper.find(Selector.LOGIN_PANEL).fadeIn();
        return false;
    }

    function showModalAfterLogin() {
        $(Selector.MESSAGE_MODAL).modal("show");
    }

    function closeLoginModal(e) {
        e.stopPropagation();
        const $btn = $(e.currentTarget);
        const $wrapper = $btn.closest(Selector.LOGIN_PANEL_WRAPPER);
        $wrapper.find(Selector.LOGIN_PANEL).fadeOut("fast")
            .trigger('eventLoginModalHasBeenClosed');
        $wrapper.find(Selector.REMIND_PASSWORD_PANEL).fadeOut("fast")
            .trigger('eventLoginModalHasBeenClosed');
        $(Selector.DARK_OVERLAY).fadeOut('fast');
        $(Selector.BODY).removeClass('overflow-hidden');
    }
})();
import * as $ from 'jquery';
import {ActualScreen, Breakpoints, getActualScreen} from 'Core/Responsiveness';
import {onClick, onLoad} from 'Core/Events';


export const LoginPanel = (() => {

    const Selector = {
        BODY: 'body',
        TOGGLER: '#login-panel--toggler, #login-panel--toggler-desktop',
        CART_STEP2_LOGIN_BTN: '#cart-step2-header-login-btn',
        CART_STEP2_LOGIN_A: '#cart-step2-header-login-a',
        LOGIN_PANEL: '#login-panel',
        LOGIN_PANEL_WRAPPER: '#login-panel-wrapper, #login-panel-wrapper-desktop',
        REMIND_PASSWORD_BTN: '#remind-password-btn',
        REMIND_PASSWORD_PANEL: '#remind-password-panel',
        BACK_TO_LOGIN_PANEL_BTN: '#back-to-login-from-remind-panel',
        DARK_OVERLAY: '.dark-overlay--for-login',
        NAVBAR_COLLAPSE: '.navbar-collapse',
        MESSAGE_MODAL: '#MessageModal',
        CLOSE_BTN: '.close-panel-button',
        TOOLTIP: '[data-toggle="tooltip"]'
    };

    onLoad(showModalAfterLogin);
    onClick(Selector.TOGGLER, togglePanelVis);
    onClick(Selector.CART_STEP2_LOGIN_BTN, togglePanelVis);
    onClick(Selector.CART_STEP2_LOGIN_A, togglePanelVis);
    onClick(Selector.REMIND_PASSWORD_BTN, showRemindPasswordPanel);
    onClick(Selector.BACK_TO_LOGIN_PANEL_BTN, backFromRemindPasswordPanel);
    onClick(Selector.CLOSE_BTN, closeLoginModal);

    function togglePanelVis(e: JQueryEventObject) {
        e.stopPropagation();
        $(Selector.TOOLTIP).tooltip('hide');
        
        // Find the login panel within the same wrapper as the clicked toggler
        const $toggler = $(e.currentTarget);
        let $wrapper = $toggler.closest(Selector.LOGIN_PANEL_WRAPPER);
        
        // If button is not inside a wrapper (e.g. cart step2 login button), find the visible one in the header
        if (!$wrapper.length) {
            $wrapper = $(Selector.LOGIN_PANEL_WRAPPER).filter(':visible').first();
        }
        
        const $loginPanel = $wrapper.find(Selector.LOGIN_PANEL);
        const $remindPanel = $wrapper.find(Selector.REMIND_PASSWORD_PANEL);
        
        if ($loginPanel.is(':visible') || $remindPanel.is(':visible')) {
            $loginPanel.fadeOut('fast');
            $remindPanel.fadeOut('fast');

        } else {
            $loginPanel.fadeIn();
            getActualScreen();
            if (ActualScreen.WIDTH <= Breakpoints.LG) {
                $loginPanel.fadeIn();
                $(Selector.NAVBAR_COLLAPSE).fadeIn('fast');
                // ^ If login-panel is placed inside navbar, navbar has to be expanded if you want to show him. Otherwise you will show Dark overlay only, without panel
                $(Selector.DARK_OVERLAY).fadeIn('fast');
                $(Selector.BODY).addClass('overflow-hidden');
            }
        }
    }

    //  REMIND PASSWORD FUNCTIONALITY
    function showRemindPasswordPanel(e) {
        e.stopPropagation();
        const $btn = $(e.currentTarget);
        const $wrapper = $btn.closest(Selector.LOGIN_PANEL_WRAPPER);
        $wrapper.find(Selector.LOGIN_PANEL).fadeOut();
        $wrapper.find(Selector.REMIND_PASSWORD_PANEL).fadeIn();
        return false;
    }

    function backFromRemindPasswordPanel(e) {
        e.stopPropagation();
        const $btn = $(e.currentTarget);
        const $wrapper = $btn.closest(Selector.LOGIN_PANEL_WRAPPER);
        $wrapper.find(Selector.REMIND_PASSWORD_PANEL).fadeOut();
        $wrapper.find(Selector.LOGIN_PANEL).fadeIn();
        return false;
    }

    function showModalAfterLogin() {
        $(Selector.MESSAGE_MODAL).modal("show");
    }

    function closeLoginModal(e) {
        e.stopPropagation();
        const $btn = $(e.currentTarget);
        const $wrapper = $btn.closest(Selector.LOGIN_PANEL_WRAPPER);
        $wrapper.find(Selector.LOGIN_PANEL).fadeOut("fast")
            .trigger('eventLoginModalHasBeenClosed');
        $wrapper.find(Selector.REMIND_PASSWORD_PANEL).fadeOut("fast")
            .trigger('eventLoginModalHasBeenClosed');
        $(Selector.DARK_OVERLAY).fadeOut('fast');
        $(Selector.BODY).removeClass('overflow-hidden');
    }
})();
